import {
  GET_ANNONCES,
  GET_ANNONCES_BY_USER,
  CREATE_ANNONCE,
  DELETE_ANNONCE,
  ADD_TO_FAVORITES,
  REMOVE_FROM_FAVORITES,
  GET_ANNONCES_FAVORIS,
} from "../actions/annonce.action";

const initialState = {
  annonces: [],
  annoncesByUser: [],
  favoris: [],
  total: 0,
  totalPages: 1,
};

export default function annonceReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ANNONCES:
      return {
        ...state,
        annonces: action.payload.annonces,
        total: action.payload.total,
        totalPages: action.payload.totalPages,
      };
    case GET_ANNONCES_BY_USER:
      return {
        ...state,
        annoncesByUser: action.payload,
      };
    case CREATE_ANNONCE:
      return {
        ...state,
        annonces: [action.payload, ...state.annonces],
      };
    case DELETE_ANNONCE:
      return {
        ...state,
        annonces: state.annonces.filter((annonce) => annonce._id !== action.payload),
      };
    case ADD_TO_FAVORITES:
      return {
        ...state,
        annonces: state.annonces.map((annonce) => {
          if (annonce._id === action.payload.annonceId) {
            return {
              ...annonce,
              favoris: [...annonce.favoris, action.payload.userId],
            };
          }
          return annonce;
        }),
      };
    case REMOVE_FROM_FAVORITES:
      return {
        ...state,
        annonces: state.annonces.map((annonce) => {
          if (annonce._id === action.payload.annonceId) {
            return {
              ...annonce,
              favoris: annonce.favoris.filter(
                (id) => id !== action.payload.userId
              ),
            };
          }
          return annonce;
        }),
      };
    case GET_ANNONCES_FAVORIS:
      return {
        ...state,
        favoris: action.payload,
      };
    default:
      return state;
  }
};
